import React, { useEffect, useState } from "react";
import { BiRefresh } from "react-icons/bi";

const FilterComponent = ({ setFilters, filters, categoryOptions }) => {
  const [applicationOptions, setApplicationOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleRefresh = () => {
    setFilters({
      search: "",
      category: "",
      applicable: "",
      model: "",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [applicationResponse, modelResponse] = await Promise.all([
          fetch(`https://api.hsagold.in/products_app/applications_list`, {
            method: "GET",
          }),
          fetch(`https://api.hsagold.in/products_app/model_list`, {
            method: "GET",
          }),
        ]);

        const applicationResult = await applicationResponse.json();
        const modelResult = await modelResponse.json();

        if (applicationResult.status) {
          const applications = Array.isArray(
            applicationResult?.SuitableApplication
          )
            ? [
                ...applicationResult.SuitableApplication.map(
                  (app) => app.application
                ),
              ]
            : [];
          setApplicationOptions(applications);
        } else {
          throw new Error(
            applicationResult.message || "Error fetching Application"
          );
        }

        if (modelResult.status) {
          const models = Array.isArray(modelResult?.SuitableModel)
            ? [...modelResult.SuitableModel.map((mod) => mod.model)]
            : [];
          setModelOptions(models);
        } else {
          throw new Error(modelResult.message || "Error fetching Model");
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="bg-white rounded-xl p-4">
      <div className="flex w-fullitems-center">
        <a
          href={`https://scan.hsagold.in/products/all/index.pdf`}
          target="_blank"
          rel="noreferrer"
          className="mx-auto mb-2 px-4 py-2 rounded-xl inline text-white outline-none cursor-pointer bg-green-700 hover:bg-green-800"
        >
          View All category PDF
        </a>
      </div>

      <div className="flex flex-wrap w-full gap-2 p-2">
        <div className="lg:flex-2 min-w-36 w-full sm:flex-1">
          <label className="font-medium mb-1 block">Category</label>
          <select
            name="category"
            value={filters.category}
            onChange={handleInputChange}
            className="px-2 py-1.5 block w-full border-2 border-gray-300 rounded-md outline-none focus:border-green-600"
          >
            <option value="">All</option>
            {categoryOptions.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div className="flex-3 min-w-36 w-full">
          <label className="font-medium mb-1 block">Suitable Model</label>
          <select
            name="model"
            value={filters.model}
            onChange={handleInputChange}
            className="px-2 py-1.5 block w-full border-2 border-gray-300 rounded-md outline-none focus:border-green-600"
          >
            <option value="">All</option>
            {modelOptions.map((model) => (
              <option key={model} value={model}>
                {model}
              </option>
            ))}
          </select>
        </div>

        <div className="flex-3 min-w-36 w-full">
          <label className="font-medium mb-1 block">Suitable Application</label>
          <select
            name="applicable"
            value={filters.applicable}
            onChange={handleInputChange}
            className="px-2 py-1.5 block w-full border-2 border-gray-300 rounded-md outline-none focus:border-green-600"
          >
            <option value="">All</option>
            {applicationOptions.map((application) => (
              <option key={application} value={application}>
                {application}
              </option>
            ))}
          </select>
        </div>

        <div className="flex-4 min-w-36 w-full">
          <label htmlFor="search" className="flex-1 min-w-36 w-full relative">
            <div className="font-medium mb-1">Search</div>
            <input
              id="search"
              name="search"
              type="search"
              placeholder="Product name"
              value={filters.search}
              onChange={handleInputChange}
              className="px-2 py-1 block w-full border-2 rounded-md outline-none focus:border-green-600 border-gray-300"
            />
          </label>
        </div>

        <div className="mt-auto">
          <button
            onClick={handleRefresh}
            className="flex items-center gap-2 py-2 px-4 rounded-xl outline-none cursor-pointer bg-gray-200 hover:bg-gray-300"
          >
            <span>Reset</span>
            <BiRefresh />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
